module.exports = "/images/Masonry---Screenshots.jpg";